// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"47":"af4ee628","385":"0fee7389","854":"dead5472"}[chunkId] + ".css";
};